module.exports = { "default": require("core-js/library/fn/reflect/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/babel-runtime/core-js/reflect/define-property.js
// module id = 944
// module chunks = 48 49 50